/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import Select from "react-select";

const TSSelect = props => {
  const [defaultValue, setDefaultValue] = useState({
    label: null,
    value: null
  });

  var [options] = useState({
    label: null,
    value: null
  });

  var [disabled] = useState(false);

  if (props.options != null) {
    options = props.options;
  }
  if (props.disabled != null) {
    disabled = props.disabled;
  }
  const customStyles = {
    container: base => ({ ...base, zIndex: props.zIndex }),
    menu: base => ({ ...base, textAlign: "left", fontSize: "1.2em" }),
    singleValue: base => ({ ...base, fontSize: "1.2em" })
  };

  useEffect(() => {
    if (props.clear != null) {
      setDefaultValue(props.clear);
    }
  }, [props.clear]);

  useEffect(() => {
    if (props.default !== null) {
      setDefaultValue(props.default);
    }
  }, []);

  useEffect(() => {
    if (props.defaulfAdd !== null && props.defaulfAdd !== undefined) {
      setDefaultValue(props.defaulfAdd);
    }
  }, [props.defaulfAdd]);

  useEffect(() => {
    if (props.defaulfAdd2 != null && props.defaulfAdd2[0].value != "") {
      setDefaultValue(props.defaulfAdd2);
    }
  }, [props.defaulfAdd2]);

  function handleChange(e) {
    if (props.onChange) {
      props.onChange(e.value);

      setDefaultValue(e);
    }
  }

  return (
    <div>
      <Select
        styles={customStyles}
        options={options}
        onChange={handleChange}
        value={defaultValue}
        isDisabled={disabled}
      />
    </div>
  );
};

export default TSSelect;
